import { CommonHeaderComponent } from './../../components/common-header/common-header';
import { Component, NgZone, ViewChild } from '@angular/core';
import { IonicPage, Tabs, Platform } from 'ionic-angular';
import { FirebaseServiceProvider } from './../../providers/firebase-service/firebase-service';
import { LokiDbProvider } from './../../providers/loki-db/loki-db';
import { NavController, NavParams, Content } from 'ionic-angular';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebaseApp from 'firebase/app';

@IonicPage()
@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tab1Root = 'ContactsPage';
  tab2Root = 'FindPage';
  tab3Root = 'NotificationsPage';
  tab4Root = 'StarredPage';
  tab5Root = 'SettingsPage';

  tabsButtons = [];

  dataLoaded = false

  @ViewChild(Tabs) tabs: Tabs;
  @ViewChild(Content) content: Content;

  homePageStart = 1; //home page iniziale dopo login, default la prima

  public tabsCheckDesktop1024 = 'tabbar-mobile';

  constructor(public firebase: FirebaseServiceProvider,
    public navCtrl: NavController,
    public platform: Platform,
    private autenticazione: AngularFireAuth,
    private lokiDB: LokiDbProvider,
    public zone: NgZone) {
    //qui cambio valore di home page

    //aggiungiamo i nomi dei tabs all'array da visualizzare nel menu laterale
    this.tabsButtons.push({ title: this.tab1Root });
    this.tabsButtons.push({ title: this.tab2Root });
    this.tabsButtons.push({ title: this.tab3Root });
    this.tabsButtons.push({ title: this.tab4Root });
    this.tabsButtons.push({ title: this.tab5Root });



    if (this.platform.is('core') && this.platform.width() > 1024) {
      this.tabsCheckDesktop1024 = 'hide-tabbar';
    } else {
      this.goToCorrectHomePage();
    }

    //Gestisce i caricamento di dati rapido nel caso in cui sia 
    //già stato eseguito il login e validato 
    /* 
    if (!this.lokiDB.allDataLoaded && this.lokiDB.getValidDomain() == 'true') {
      console.log("Valid Domain by stored data")
      this.lokiDB.getAllData();
    }
    */

    firebaseApp.auth().onAuthStateChanged(user => {
      if (user) {
        console.log("signed in -> ");
        console.log(user);
        this.lokiDB.getTokenWaiter().then(() => {
          this.lokiDB.checkLoginDomain(user).then((ok) => {
            if (!ok) {
              console.log("Invalid Domain")
              this.navCtrl.setRoot('LoginPage');
            } else {
              this.lokiDB.trackUserMail(user);
            }
          }).catch((err) => {
              console.log("Unabled to verify domain")              
              this.navCtrl.setRoot('LoginPage');
          });
        });
      } else {
        console.log("Signed out");
        this.navCtrl.setRoot('LoginPage');
      };
    });

    if (!platform.is('core')) {
      // cliccato sulla notifica 
      platform.ready().then(() => {
        this.lokiDB.pushObject.on('notification').subscribe((n: any) => {
          //In questo caso l'app è stata aperta premendo sulla notifica
          //allora seleziono la pagina delle notifiche
          if (n.additionalData.coldstart || !n.additionalData.foreground) {
            console.log("**********APP APERTA DA NOTIFICA*********")
            this.tabs.select(2);
          }
        });
      });
    }


  }

  ionViewWillEnter() {
    //console.log("TABS ion view will enter");

  }


  forceSelected() {
    this.zone.run(() => {
      this.tabs.select(this.tabs.getSelected().index);
    });
  }

  goToCorrectHomePage() {
    let tabIdx = this.lokiDB.getHomePage();
    if (!isNaN(tabIdx) && tabIdx >= 0) {
      this.homePageStart = tabIdx;
    }
  }



}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts